module.exports = __webpack_public_path__ + "img/logo.42d686ef.png";